'use strict';

var styled = require('styled-components');
var cell = require('./cell.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const CellSubTextStyled = styled__default.default(cell.Cell) `
  line-height: 1rem;
`;
const CellSubTextSecondaryText = styled__default.default.span `
  color: ${({ theme }) => theme.palette.grey500};
`;

exports.CellSubTextSecondaryText = CellSubTextSecondaryText;
exports.CellSubTextStyled = CellSubTextStyled;
//# sourceMappingURL=cellSubText.styles.js.map
